import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface CrestProps {
    className?: string
    title?: string
}

/**
 * The school crest: an elm on a navy shield. Drawn as SVG so it stays sharp at
 * any size and picks up the brand colours.
 */
export const Crest: FC<CrestProps> = ({ className, title }): ReactNode => {
    return (
        <svg
            viewBox='0 0 64 72'
            xmlns='http://www.w3.org/2000/svg'
            className={cn('shrink-0', className)}
            role={title ? 'img' : undefined}
            aria-label={title}
            aria-hidden={title ? undefined : true}
            focusable='false'
        >
            <path
                d='M32 2.5 59 9.5V33c0 17.5-11.5 29.5-27 36.5C16.5 62.5 5 50.5 5 33V9.5Z'
                className='fill-navy stroke-gold'
                strokeWidth='2.5'
                strokeLinejoin='round'
            />
            <path
                d='M32 7.4 54.4 13v20c0 14.6-9.3 24.9-22.4 31.2C18.9 57.9 9.6 47.6 9.6 33V13Z'
                className='fill-none stroke-gold'
                strokeOpacity='0.45'
                strokeWidth='1'
            />
            <g className='fill-gold'>
                <circle cx='32' cy='23.5' r='8.5' />
                <circle cx='24.6' cy='27.6' r='6.4' />
                <circle cx='39.4' cy='27.6' r='6.4' />
                <circle cx='27.2' cy='19.6' r='5.8' />
                <circle cx='36.8' cy='19.6' r='5.8' />
                <circle cx='32' cy='30.4' r='5.6' />
                <path d='M30.5 32.5h3l.6 12.2c.2 1.9 1.4 3.2 3.4 3.9h-11c2-.7 3.2-2 3.4-3.9Z' />
            </g>
            <path
                d='M15.5 51.5c10.6 3.7 22.4 3.7 33 0'
                className='fill-none stroke-gold'
                strokeWidth='2'
                strokeLinecap='round'
            />
            <g className='fill-gold'>
                <circle cx='24' cy='57.6' r='1.3' />
                <circle cx='32' cy='59.4' r='1.3' />
                <circle cx='40' cy='57.6' r='1.3' />
            </g>
        </svg>
    )
}
